import { server } from "typescript";
import { Customer, api } from "./customers";

export interface DashboardCustomersResponse {
  status: string;
  message: string;
  total_count: number;
  total_pages: number;
  current_page: number;
  data: Customer[];
  per_page: number;
  prev_page: number;
  nextPage: number;
}

export interface DashboardHealthIssues {
  id: number;
  name: string;
  descriptions: string;
  others: string;
  mode: string;
  status: number;
  comments: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}
export interface DashboardWellness {}

export interface DashboardStatus {
  id: number;
  name: string;
  descriptions: string;
  others: string;
  mode: string;
  status: number;
}

export interface CustomerJourneyType {
  id: number;
  name: string;
  descriptions: string;
  others: string;
  status: string;
}

export interface DashboardRemindedFor {
  id: number;
  name: string;
  descriptions: string;
  others: string;
  mode: string;
  status: number;
}

export interface DashboardRemindedTo {
  id: number;
  name: string;
  descriptions: string;
  others: string;
  mode: string;
  status: number;
}
export interface DashBoardCount {
  id: number;
  name: string;
  descriptions: string;
  others: string;
  status: string;
}
export interface SocialAge {
  id: number;
  data: [];
  descriptions: string;
  others: string;
  status: string;
}
export interface PageClick {
  id: number;
  data: [];
  status: string;
}
export interface SocialEngagement {
  id: number;
  data: any;
  status: string;
}
export interface LinkClicks {
  id: number;
  data: [];
  status: string;
}
export interface AccountDetails {
  id: number;
  data: [];
  status: string;
}
export interface SocialReach {
  id: number;
  data_impression: any;
  data_reach: any;
  status: string;
}
export interface ServiceListItem {
  week: string;
  previousMonth: number;
  thisMonth: number;
}
export interface DashBoardLeads {
  service_list: ServiceListItem[];
  preServiceTotal: number;
  thisServiceTotal: number;
  city_list: ServiceListItem[];
  preCityTotal: number;
  thisCityTotal: number;
  source_list: ServiceListItem[];
  preSourceTotal: number;
  thisSourceTotal: number;
}
type DashboardWellnessResponse = DashboardWellness[];

type DashboardHealthIssuessResponse = DashboardHealthIssues[];

type DashboardStatusResponse = DashboardStatus[];

type DashboardCustomerJourneyTypeResponse = CustomerJourneyType[];

type DashboardRemindedForResponse = DashboardRemindedFor[];

type DashboardRemindedToResponse = DashboardRemindedTo[];

type DasboardCustomersResponse = DashboardCustomersResponse[];

type DashBoardTotalCount = DashBoardCount[];

export const DashboardApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWellnesschart: build.query<DashboardWellnessResponse, void>({
      query: () => "dashboard_customer_wellness",
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "DashboardWellness" as const,
                id,
              })),
              { type: "DashboardWellness", id: "LIST" },
            ]
          : [{ type: "DashboardWellness", id: "LIST" }],
      // transformResponse: (response: { data: DashboardHealthIssuessResponse }, meta, arg) => response.data,
    }),
    getDashboardHealthIssuess: build.query<
      DashboardHealthIssuessResponse,
      void
    >({
      query: () => "dashboard/health_issue",
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "DashboardHealthIssues" as const,
                id,
              })),
              { type: "DashboardHealthIssues", id: "LIST" },
            ]
          : [{ type: "DashboardHealthIssues", id: "LIST" }],
      // transformResponse: (response: { data: DashboardHealthIssuessResponse }, meta, arg) => response.data,
    }),
    getDashboardCustomers: build.query<DasboardCustomersResponse, any>({
      query: (pagi) =>
        `dashboard?page=${pagi?.pageNo}&startDate=${
          pagi?.date?.startDate ? pagi?.date?.startDate : ""
        }&endDate=${pagi?.date?.endDate ? pagi?.date?.endDate : ""}&filter=${
          pagi?.filter
        }&source=${pagi?.source}&name=${pagi?.name}&branchId=${pagi?.branchId}`,
      providesTags: (result) =>
        result
          ? [
              ...result?.["data"]?.map(({ id }) => ({
                type: "DasboardCustomers" as const,
                id,
              })),
              { type: "DasboardCustomers", id: "LIST" },
            ]
          : [{ type: "DasboardCustomers", id: "LIST" }],
    }),
    getDashboardStatuses: build.query<DashboardStatusResponse, void>({
      query: () => "dashboard/status",
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "DashboardStatus" as const,
                id,
              })),
              { type: "DashboardStatus", id: "LIST" },
            ]
          : [{ type: "DashboardStatus", id: "LIST" }],
    }),
    getDashboardCustomerJourneyTypes: build.query<
      DashboardCustomerJourneyTypeResponse,
      void
    >({
      query: () => "dashboard/customer_journey",
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "CustomerJourneyType" as const,
                id,
              })),
              { type: "CustomerJourneyType", id: "LIST" },
            ]
          : [{ type: "CustomerJourneyType", id: "LIST" }],
    }),
    getDashboardTotalCount: build.query<DashBoardCount, void>({
      query: () => "dashboard_count_new",
      providesTags: ["DashBoardCount"],
      transformResponse: (response: { data: DashBoardCount }, meta, arg) =>
        response.data,
    }),
    getSocialAgeData: build.query<SocialAge, any>({
      query: (id) => `social_age_group/${id}`,
      // providesTags: ["DashBoardCount"],
      // transformResponse: (response: { data: DashBoardCount }, meta, arg) =>
      //   response.data,
    }),
    getPageClickData: build.query<PageClick, any>({
      query: (id) => `social_page_clicks/${id}`,
      // providesTags: ["DashBoardCount"],
      // transformResponse: (response: { data: DashBoardCount }, meta, arg) =>
      //   response.data,
    }),
    getSocialEngagementData: build.query<SocialEngagement, any>({
      query: (id) => `social_engagements/${id}`,
      // providesTags: ["DashBoardCount"],
      // transformResponse: (response: { data: DashBoardCount }, meta, arg) =>
      //   response.data,
    }),
    getLinkClickData: build.query<LinkClicks, any>({
      query: (id) => `social_link_click/${id}`,
      // providesTags: ["DashBoardCount"],
      // transformResponse: (response: { data: DashBoardCount }, meta, arg) =>
      //   response.data,
    }),
    getAccountDetails: build.query<AccountDetails, any>({
      query: (id) => "social_account_details",
      // providesTags: ["DashBoardCount"],
      // transformResponse: (response: { data: DashBoardCount }, meta, arg) =>
      //   response.data,
    }),

    getSocialReachData: build.query<SocialReach, any>({
      query: (id) => `social_reach_impressions/${id}`,
      // providesTags: ["DashBoardCount"],
      // transformResponse: (response: { data: DashBoardCount }, meta, arg) =>
      //   response.data,
    }),
    getDashboardTotallead: build.query<DashBoardLeads, any>({
      query: (data) => `dashboardNew?serviceChoosen=${data?.source || ""}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: DashBoardLeads }, meta, arg) =>
        response.data,
    }),
    getDashboardSpotlight: build.query<DashBoardLeads, void>({
      query: () => "get_spotlight_analysis",
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: DashBoardLeads }, meta, arg) =>
        response.data,
    }),
    getDashboardSpotlightfeedback: build.query<DashBoardLeads, void>({
      query: () => "get_spotlight_feedbacks",
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: DashBoardLeads }, meta, arg) =>
        response.data,
    }),
    getDashboardSpotlightInsights: build.query<DashBoardLeads, void>({
      query: () => "get_spotlight_insights",
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: DashBoardLeads }, meta, arg) =>
        response.data,
    }),
    getDashboardGoogleAnalytics: build.query<DashBoardLeads, void>({
      query: () => "googleAnalyticsData",
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: DashBoardLeads }, meta, arg) =>
        response.data,
    }),
    getDashboardRemindedFor: build.query<DashboardRemindedForResponse, void>({
      query: () => "dashboard/reminder_for",
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "DashboardRemindedFor" as const,
                id,
              })),
              { type: "DashboardRemindedFor", id: "LIST" },
            ]
          : [{ type: "DashboardRemindedFor", id: "LIST" }],
    }),
    getDashboardRemindedTo: build.query<DashboardRemindedToResponse, void>({
      query: () => "dashboard/reminder_to",
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "DashboardRemindedTo" as const,
                id,
              })),
              { type: "DashboardRemindedTo", id: "LIST" },
            ]
          : [{ type: "DashboardRemindedTo", id: "LIST" }],
    }),
    getSpotlightCity: build.mutation<Customer, Partial<any>>({
      query: (body) => ({
        url: `spotlight/get_spotlight_city`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
      invalidatesTags: [
        { type: "Customer", id: "LIST" },
        { type: "DasboardCustomers", id: "LIST" },
        { type: "DashBoardCount" },
      ],
    }),
    getSpotlightbyId: build.mutation<Customer, Partial<any>>({
      query: (body) => ({
        url: `spotlight/get_spotlightbyid`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
      invalidatesTags: [
        { type: "Customer", id: "LIST" },
        { type: "DasboardCustomers", id: "LIST" },
        { type: "DashBoardCount" },
      ],
    }),
    getSpotlightbyStatics: build.mutation<Customer, Partial<any>>({
      query: (body) => ({
        url: `spotlight/get_spotlight_statics`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
      invalidatesTags: [
        { type: "Customer", id: "LIST" },
        { type: "DasboardCustomers", id: "LIST" },
        { type: "DashBoardCount" },
      ],
    }),
    getSpotlightuniquePageclick: build.mutation<Customer, Partial<any>>({
      query: (body) => ({
        url: `spotlight/unique_page_click_views`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
      invalidatesTags: [
        { type: "Customer", id: "LIST" },
        { type: "DasboardCustomers", id: "LIST" },
        { type: "DashBoardCount" },
      ],
    }),

    //New Dashboard
    getRevenueRate: build.query<any, any>({
      query: (month) => `revenue_rate_list?thisMonth=${month}`,
    }),
    getPatientCounts: build.query<any, any>({
      query: () => `rate_counts`,
    }),
    getLeadsServiceType: build.query<any, any>({
      query: (type) => `lead_counts?leadType=${type}`,
    }),
    getTopConsultants: build.query<any, any>({
      query: (type) => `top_consulant_list?thisMonth=${type}`,
    }),
    getAppointments: build.query<any, any>({
      query: (type) => `appointment_list?thisMonth=${type}`,
    }),
    getAppointmentSummary: build.query<any, any>({
      query: (type) => `appointment_summary?thisMonth=${type}`,
    }),
    getConsultantSummary: build.query<any, any>({
      query: (type) => `consultant_summary?thisMonth=${type}`,
    }),
  }),
});

export const {
  useGetWellnesschartQuery,
  useGetDashboardHealthIssuessQuery,
  useGetDashboardStatusesQuery,
  useGetDashboardCustomerJourneyTypesQuery,
  useGetDashboardRemindedForQuery,
  useGetDashboardRemindedToQuery,
  useGetDashboardCustomersQuery,
  useGetDashboardTotalCountQuery,
  useGetDashboardTotalleadQuery,
  useGetSocialEngagementDataQuery,
  useGetSocialAgeDataQuery,
  useGetSocialReachDataQuery,
  useGetPageClickDataQuery,
  useGetAccountDetailsQuery,
  useGetLinkClickDataQuery,
  useGetDashboardSpotlightQuery,
  useGetDashboardSpotlightfeedbackQuery,
  useGetDashboardSpotlightInsightsQuery,
  useGetDashboardGoogleAnalyticsQuery,
  useGetSpotlightCityMutation,
  useGetSpotlightbyIdMutation,
  useGetSpotlightbyStaticsMutation,
  useGetSpotlightuniquePageclickMutation,
  useGetRevenueRateQuery,
  useGetPatientCountsQuery,
  useGetLeadsServiceTypeQuery,
  useGetTopConsultantsQuery,
  useGetAppointmentsQuery,
  useGetAppointmentSummaryQuery,
  useGetConsultantSummaryQuery
} = DashboardApi;
